import { h } from 'preact'
import { useMemo, useCallback } from 'preact/hooks';
import { getDataByDomain } from './helper.js';
import { SearchResultRegistrar } from './searchResultRegistrar.js';
import { SearchResultSuggestions } from './searchResultSuggestions.js';
import { SearchResultPremium } from './searchResultPremium.js';

export default function ShowByDomain({ searchStr }) {
  const { domain, isLoading, isError } = getDataByDomain(searchStr)

  // console.log(registrats, isLoading, isError)
  if (isError) return <h1 class="font-semibold text-center">Connection fail, Please try again later</h1>
  if (isLoading)
    return <h1 class="font-semibold text-center">Loading...</h1>
  else {
    return domain?.domain_status === 'available' || domain?.domain_status === 'available_epp' ?
            <SearchResultRegistrar data={domain?.registrars?.data} domain={searchStr} />
          : domain?.domain_status === 'registered' ?
            <SearchResultSuggestions data={domain?.name_spinner} whois={domain?.whois_details} domain={searchStr}/>
          : domain?.domain_status === 'reserved' ?
            <SearchResultSuggestions data={domain?.name_spinner} whois={domain?.whois_details} domain={searchStr}/>
          : domain?.domain_status === 'ask_price' ?
            <SearchResultPremium data={domain?.name_spinner} similar_sales={domain?.similar_sales} domain={searchStr}/>
          : null
    
  }
}
